export default __webpack_public_path__ + "static/andre-57de610412c10014f36efeb3bc0ef52c.svg";